__turbopack_context__.v({
  "container": "HtmlContent-module__bzoKTG__container",
});
